module.exports = __webpack_public_path__ + "static/media/qa.8ceaa7b0.png";